var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"padlet-logo block",attrs:{"href":_vm.href || _vm.currentHostWithProtocol(),"aria-label":_vm.__('Go to Padlet Homepage')}},[_c('img',{class:[
      'w-full',
      _vm.type === _vm.LogoType.Light300 && ['opacity-50', 'hover-hover:hover:opacity-100', 'transition-opacity'],
      _vm.type === _vm.LogoType.Dark300 && ['opacity-[.38]', 'hover-hover:hover:opacity-100', 'transition-opacity'],
    ],attrs:{"src":_vm.logo,"alt":_vm.__('Padlet Logo')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }